export const AXIOS_ERROR_TOAST = 'AXIOS_ERROR_TOAST';

export const APP_ROOT_ELEMENT_ID = import.meta.env.VITE_APP_ROOT_ELEMENT_ID;
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const ENVIRONMENT_ID = import.meta.env.VITE_ENVIRONMENT_ID;
export const AUTHORITY = import.meta.env.VITE_AUTH_AUTHORITY;
export const CLIENT_ID = import.meta.env.VITE_AUTH_CLIENT_ID;
export const CLIENT_SECRET = import.meta.env.VITE_AUTH_CLIENT_SECRET;
